module.exports = __webpack_public_path__ + "static/media/sol-carrele.898dbf01.svg";